import React from 'react';
import {Link} from 'react-scroll';
import Section from '../Terms/Section';
import '../Terms/Styles/Container.scss';
import { privacyData } from './data';
const Container=()=>{
    return(
        <div className="terms-container">

            <div className="content">
                <h1>Privacy and Cookie Policy</h1>
                <h3>EFFECTIVE DATE: FEBRUARY 25, 2021</h3>
                 {privacyData.map((d) =>{
                     return(
                         <div id={d.id} >
                             <Section 
                             {...d}
                             />
                         </div>
                     )
                 })}
            </div>
         <div className="links-container">
        
                 <Link
                 activeClass="isActive"
                 to="first"
                 spy={true}
                 smooth={true}
                 offset={-250}
                 duration={500}
                 >
                1. Introduction; Your Agreement to these Privacy
                 </Link>
                 <Link
                 activeClass="isActive"
                 to="second"
                 spy={true}
                 smooth={true}
                 offset={-250}
                 duration={500}
                 >
                    2. Important information and who we are
                 </Link>
                 <Link
                 activeClass="isActive"
                 to="third"
                 spy={true}
                 smooth={true}
                offset={-250}
                 duration={500}
                 >
                3. The data we collect about you
                 </Link>
                 <Link
                 activeClass="isActive"
                 to="fourth"
                 spy={true}
                offset={-280}
                 offset={0}
                 duration={500}
                 >
               4. How is your personal data collected?
                 </Link>
                 <Link
                 activeClass="isActive"
                 to="fifth"
                 spy={true}
                 smooth={true}
                offset={-100}
                 duration={500}
                 >
               5. How we use your personal data
                 </Link>
                 <Link
                 activeClass="isActive"
                 to="sixth"
                 spy={true}
                 smooth={true}
                offset={-100}
                 duration={500}
                 >
             6. Cookies
                 </Link>
                 <Link
                 activeClass="isActive"
                 to="seventh"
                 spy={true}
                 smooth={true}
                offset={-250}
                 duration={500}
                 >
              7. Disclosures of your personal data
                 </Link>
                 <Link
                 activeClass="isActive"
                 to="eight"
                 spy={true}
                 smooth={true}
                offset={-250}
                 duration={500}
                 >
           8. International transfers
                 </Link>
          
         </div>
        </div>
    )
};
export default Container ;